import { HubAction } from './hub.action';

export class OrderEditingListAction extends HubAction {
    constructor(orderNumber: number) {
        super('GetEditingUserListForOrder', orderNumber);
    }

    public action(): void {
        // nothing to do
    }
}
